const HANDSHAKE_TIMEOUT_MS = 1500;

export async function attemptEmbedAuth(): Promise<void> {
  const embedUIURL = CONFIG.ui.embedUIURL;
  if (!embedUIURL) {
    return;
  }

  const embedOrigin = new URL(embedUIURL).origin;

  await new Promise<void>((resolve) => {
    const timeout = setTimeout(() => {
      window.removeEventListener('message', handleMessage);
      resolve();
    }, HANDSHAKE_TIMEOUT_MS);

    function handleMessage(event: MessageEvent) {
      if (event.origin !== embedOrigin) {
        return;
      }
      if (event.data?.type !== 'mesa-embed-auth') {
        return;
      }

      const { clientId, username, idToken, accessToken, refreshToken } = event.data;
      if (!clientId || !username || !idToken || !accessToken || !refreshToken) {
        return;
      }

      clearTimeout(timeout);
      window.removeEventListener('message', handleMessage);

      const prefix = `CognitoIdentityServiceProvider.${clientId}`;
      localStorage.setItem(`${prefix}.LastAuthUser`, username);
      localStorage.setItem(`${prefix}.${username}.idToken`, idToken);
      localStorage.setItem(`${prefix}.${username}.accessToken`, accessToken);
      localStorage.setItem(`${prefix}.${username}.refreshToken`, refreshToken);
      localStorage.setItem(`${prefix}.${username}.clockDrift`, '0');

      resolve();
    }

    window.addEventListener('message', handleMessage);
    window.opener.postMessage({ type: 'mesa-vendor-ready' }, embedOrigin);
  });
}
